import { render } from "./input.vue?vue&type=template&id=24675c6c&scoped=true"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import "./input.vue?vue&type=style&index=0&id=24675c6c&lang=scss&scoped=true"

import exportComponent from "/Users/alessiopracchia/Projects/innexta/bilanci/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24675c6c"]])

export default __exports__